export const FETCH_DOCUMENTS_BY_RESOURCE_ID = 'fetchDocumentsByResourceId';
export const CREATE_DOCUMENT = 'createDocument';
export const FETCH_DOCUMENT_BY_ID = 'fetchDocumentById';
export const DELETE_DOCUMENT_BY_ID = 'deleteDocumentById';
